import thunk from 'redux-thunk';
import { compose } from "redux";
import { applyMiddleware } from 'redux';
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import storeConfiguration from "./storeConfiguration"

// eslint-disable-next-line @typescript-eslint/no-explicit-any

// NODE_ENV is always 'production' for both development and production build!!! 
const composeEnhancers = (process.env.NODE_ENV === 'development' && (window as any)?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const store = storeConfiguration(composeEnhancers(applyMiddleware(thunk)));

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

